// File: cgp-user-profile-dialog-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile module.
// Other Contributors:

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { CgpUserProfileDialogComponent } from "./cgp-user-profile-dialog.component";
import { CgpUserProfileDialogService } from "./cgp-user-profile-dialog.service";

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule
    ],
    exports: [
        CgpUserProfileDialogComponent
    ],
    declarations: [
        CgpUserProfileDialogComponent
    ],
    providers: [
        CgpUserProfileDialogService
    ]
})
export class CgpUserProfileDialogModule { }